import React, {useContext, useEffect} from "react";
import {useFormContext} from "react-hook-form";
import {Link} from 'react-router-dom'

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { DataGrid } from '@mui/x-data-grid';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';

import * as CustomStyles from '../styles/CustomStyles';
import * as ValidationMessages from '../constants/ValidationMessages';
import * as SelectTypes from '../constants/CustomSelectTypes';
import CustomSelect from '../custom/CustomSelectComponent'
import * as DataPattern from '../constants/DataPattern';
import {getGeoLocation} from '../util/Calculators';
import * as RestCalls from '../../utils/network/RestCalls';
import { Loading } from "../custom/LoadingComponent";
import { ClientType, ServiceType } from "../constants/Consts";
import * as AFUtility from '../util/AFUtility';

//
// It is expected that <FormProvider> provides all the hook methods in the parent before calling the below components
// The components access the methods (register, formState, errors, etc...) by using useFormContext()
// lEmployee is expected to be in the local form state
//

export function RenderGeneralSection(props) {
    console.log('Sectiune Generala...');
    const { register, formState: { errors, defaultValues } } = useFormContext();

    const [selectedClientType, setSelectedClientType] = React.useState(defaultValues.lClient.generalSection.clientType);

    var rsvtiProviderClient = null;
    if(defaultValues.lClient.generalSection.rsvtiServiceType === ServiceType.External) {
        rsvtiProviderClient = props.allClients.find((client) => client.id === defaultValues.lClient.generalSection.rsvtiServiceByClientId);
    }


    return(
        <Box sx={CustomStyles.boxStyles}  >
            <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Delatii Generale</Typography>

            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                {/*row*/}
                <Grid item xs={8}>
                    <TextField variant="standard" size="small" label="Nume Client" fullWidth margin="dense" 
                        {...register("lClient.generalSection.clientName", {required: ValidationMessages.REQUITED_MESSAGE})} 
                        error={!!errors?.lClient?.generalSection?.clientName}
                        helperText={errors?.lClient?.generalSection?.clientName ? errors.lClient.generalSection.clientName.message : null}
                    />
                </Grid>
                <Grid item xs={4}>
                    <CustomSelect 
                        disabled={!!defaultValues.lClient.id}
                        callback={setSelectedClientType}
                        selectId={'clientTypeId'} 
                        selectType={SelectTypes.CLIENT_TYPE} 
                        value={defaultValues.lClient.generalSection.clientType} 
                        register={{...register('lClient.generalSection.clientType', {required: ValidationMessages.REQUITED_MESSAGE})}}
                        error={!!errors?.lClient?.generalSection?.clientType}
                        helperText={errors?.lClient?.generalSection?.clientType ? errors.lClient.generalSection.clientType.message : null}
                    />   
                </Grid>
                {selectedClientType === ClientType.Angajator &&
                <React.Fragment>
                    <Grid item xs={4}>
                        <CustomSelect 
                            disabled={!!defaultValues.lClient.id}
                            label={'Tipul Serviciului RSVTI'}
                            selectId={'rsvtiServiceTypeId'} 
                            selectType={SelectTypes.CLIENT_SERVICE_TYPE} 
                            value={defaultValues.lClient.generalSection.rsvtiServiceType} 
                            register={{...register('lClient.generalSection.rsvtiServiceType', {required: ValidationMessages.REQUITED_MESSAGE})}}
                            error={!!errors?.lClient?.generalSection?.rsvtiServiceType}
                            helperText={errors?.lClient?.generalSection?.rsvtiServiceType ? errors.lClient.generalSection.rsvtiServiceType.message : null}
                        />   
                    </Grid>
                    <Grid item xs={8}  sx={{ display: 'flex'}} >
                        {defaultValues.lClient.generalSection.rsvtiServiceType === ServiceType.External &&
                            <Box sx={{ display: 'flex', alignItems: 'center', marginLeft: 2}} >
                                <Typography paddingLeft={2} paddingTop={1}>{rsvtiProviderClient.generalSection.clientName}</Typography>
                            </Box>
                        }
                    </Grid>

                </React.Fragment>
                }

            </Grid>
        </Box>
    );
}

export function RenderCompanySection() {
    console.log('Sectiune Generala...');
    const { register, formState: { errors, defaultValues } } = useFormContext();

    return(
        <Box sx={CustomStyles.boxStyles}  >
            <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Delatii Companie</Typography>

            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                {/*row*/}
                <Grid item xs={6}>
                    <TextField variant="standard" size="small" label="Nr. Registrul Comertului" fullWidth margin="dense" 
                        {...register("lClient.clientDetails.registrulComertului", {required: ValidationMessages.REQUITED_MESSAGE})} 
                        error={!!errors?.lClient?.clientDetails?.registrulComertului}
                        helperText={errors?.lClient?.clientDetails?.registrulComertului ? errors.lClient.clientDetails.registrulComertului.message : null}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField variant="standard" size="small" label="Cod Unic de Inregistrare (CUI)" fullWidth margin="dense" 
                        {...register("lClient.clientDetails.codUnic", {required: ValidationMessages.REQUITED_MESSAGE})} 
                        error={!!errors?.lClient?.clientDetails?.codUnic}
                        helperText={errors?.lClient?.clientDetails?.codUnic ? errors.lClient.clientDetails.codUnic.message : null}
                    />
                </Grid>
                {/*row*/}
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Nume Reprezentant Legal" fullWidth margin="dense" 
                        {...register("lClient.clientDetails.legalRepresentativeName")} 
                        error={!!errors?.lClient?.clientDetails?.legalRepresentativeName}
                        helperText={errors?.lClient?.clientDetails?.legalRepresentativeName ? errors.lClient.clientDetails.legalRepresentativeName.message : null}
                    />
                </Grid>
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Telefon Reprezentant Legal" fullWidth margin="dense" 
                        {...register("lClient.clientDetails.legalRepresentativePhone",
                            {pattern: {
                                value: DataPattern.PATTERN_PHONE_NUMBER,
                                message: ValidationMessages.INVALID_PHONE_NUMBER,
                            }}
                        )} 
                        error={!!errors?.lClient?.clientDetails?.legalRepresentativePhone}
                        helperText={errors?.lClient?.clientDetails?.legalRepresentativePhone ? errors.lClient.clientDetails.legalRepresentativePhone.message : null}
                    />
                </Grid>
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Email Reprezentant Legal" fullWidth margin="dense" 
                        {...register("lClient.clientDetails.legalRepresentativeEmail",
                            {pattern: {
                                value: DataPattern.PATTERN_EMAIL_ADDRESS,
                                message: ValidationMessages.INVALID_EMAIL_ADDRESS,
                            }}
                        )} 
                        error={!!errors?.lClient?.clientDetails?.legalRepresentativeEmail}
                        helperText={errors?.lClient?.clientDetails?.legalRepresentativeEmail ? errors.lClient.clientDetails.legalRepresentativeEmail.message : null}
                    />
                </Grid>
                {/*row*/}
                <Grid item xs={6}>
                    <TextField variant="standard" size="small" label="Cont Bancar" fullWidth margin="dense" 
                        {...register("lClient.clientDetails.bankingInfo")} 
                        error={!!errors?.lClient?.clientDetails?.bankingInfo}
                        helperText={errors?.lClient?.clientDetails?.bankingInfo ? errors.lClient.clientDetails.bankingInfo.message : null}
                    />
                </Grid>
                <Grid item xs={6}>
                </Grid>

            </Grid>
        </Box>
    );
}



export function RenderAdresaSediuSection() {
    console.log('Adresa Sediu ');
    const { register, setValue, watch, trigger, formState: { errors, defaultValues } } = useFormContext();


    const handleJudetChange = (judet) => {
        setValue('lClient.headOffice.localizareGeografica', getGeoLocation(judet));
        trigger('lClient.headOffice.localizareGeografica');
        // trigger('headofficeJudet-inputLabelId');
    }


    return(
        <Box sx={CustomStyles.boxStyles}  >
          <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Adresa Sediu</Typography>

          <Grid container spacing={2} sx={CustomStyles.gridStyles}>
            {/*row*/}
            <Grid item xs={4}>
                <CustomSelect 
                    callback={handleJudetChange}
                    selectId={'headofficeJudet'} 
                    selectType={SelectTypes.JUDETE} 
                    value={defaultValues.lClient.headOffice.judet} 
                    register={{...register('lClient.headOffice.judet', {required: ValidationMessages.REQUITED_MESSAGE})}}
                    error={!!errors?.lClient?.headOffice?.judet}
                    helperText={errors?.lClient?.headOffice?.judet ? errors.lClient?.headOffice?.judet.message : null}
                />   
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Localizare Geografica" fullWidth margin="dense" disabled
                    {...register("lClient.headOffice.localizareGeografica", {required: ValidationMessages.REQUITED_MESSAGE})} 
                    error={!!errors?.lClient?.headOffice?.localizareGeografica}
                    helperText={errors?.errors?.lClient?.headOffice?.localizareGeografica ? errors.errors?.lClient?.headOffice?.localizareGeografica.message : null}
                    inputRef={register()}
                    InputLabelProps={{ shrink: !!watch('lClient.headOffice.localizareGeografica') }}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField variant="standard" size="small" label="Localitate" fullWidth margin="dense" 
                    {...register("lClient.headOffice.localitate", {required: ValidationMessages.REQUITED_MESSAGE})} 
                    error={!!errors?.lClient?.headOffice?.localitate}
                    helperText={errors?.lClient?.headOffice?.localitate ? errors.lClient?.headOffice?.localitate.message : null}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Sector" fullWidth margin="dense" 
                    {...register("lClient.headOffice.sector")} 
                    error={!!errors?.lClient?.headOffice?.sector}
                    helperText={errors?.lClient?.headOffice?.sector ? errors.lClient?.headOffice?.sector.message : null}
                />
            </Grid>

            {/*row*/}
            <Grid item xs={4}>
                <TextField variant="standard" size="small" label="Cod Postal" fullWidth margin="dense" 
                    {...register("lClient.headOffice.postalCode", {required: ValidationMessages.REQUITED_MESSAGE})} 
                    error={!!errors?.lClient?.headOffice?.postalCode}
                    helperText={errors?.lClient?.headOffice?.postalCode ? errors.lClient?.headOffice?.postalCode.message : null}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField variant="standard" size="small" label="Strada" fullWidth margin="dense" 
                    {...register("lClient.headOffice.street", {required: ValidationMessages.REQUITED_MESSAGE})} 
                    error={!!errors?.lClient?.headOffice?.street}
                    helperText={errors?.lClient?.headOffice?.street ? errors.lClient?.headOffice?.street.message : null}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField variant="standard" size="small" label="Nr." fullWidth margin="dense" 
                    {...register("lClient.headOffice.no")} 
                    error={!!errors?.lClient?.headOffice?.no}
                    helperText={errors?.lClient?.headOffice?.no ? errors.lClient?.headOffice?.no.message : null}
                />
            </Grid>


            {/*row*/}
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Bloc" fullWidth margin="dense" 
                    {...register("lClient.headOffice.bloc")} 
                    error={!!errors?.lClient?.headOffice?.bloc}
                    helperText={errors?.lClient?.headOffice?.bloc ? errors.lClient?.headOffice?.bloc.message : null}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Scara" fullWidth margin="dense" 
                    {...register("lClient.headOffice.scara")} 
                    error={!!errors?.lClient?.headOffice?.scara}
                    helperText={errors?.lClient?.headOffice?.scara ? errors.lClient?.headOffice?.scara.message : null}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Etaj" fullWidth margin="dense" 
                    {...register("lClient.headOffice.etaj")} 
                    error={!!errors?.lClient?.headOffice?.etaj}
                    helperText={errors?.lClient?.headOffice?.etaj ? errors.lClient?.headOffice?.etaj.message : null}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Apartament" fullWidth margin="dense" 
                    {...register("lClient.headOffice.apartment")} 
                    error={!!errors?.lClient?.headOffice?.apartment}
                    helperText={errors?.lClient?.headOffice?.apartment ? errors.lClient?.headOffice?.apartment.message : null}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Buzzer" fullWidth margin="dense" 
                    {...register("lClient.headOffice.buzzer")} 
                    error={!!errors?.lClient?.headOffice?.buzzer}
                    helperText={errors?.lClient?.headOffice?.buzzer ? errors.lClient?.headOffice?.buzzer.message : null}
                />
            </Grid>
            <Grid item xs={2}>
            </Grid>

            {/*row*/}
            <Grid item xs={3}>
                <TextField variant="standard" size="small" label="Telefon" fullWidth margin="dense" 
                    {...register("lClient.headOffice.phone", 
                        {required: ValidationMessages.REQUITED_MESSAGE,
                            pattern: {
                                value: DataPattern.PATTERN_PHONE_NUMBER,
                                message: ValidationMessages.INVALID_PHONE_NUMBER,
                            }  
                        }
                    )} 
                    error={!!errors?.lClient?.headOffice?.phone}
                    helperText={errors?.lClient?.headOffice?.phone ? errors.lClient?.headOffice?.phone.message : null}
                />
            </Grid>
            <Grid item xs={1}>
                <TextField variant="standard" size="small" label="Interior" fullWidth margin="dense" 
                    {...register("lClient.headOffice.phoneExtension")} 
                    error={!!errors?.lClient?.headOffice?.phoneExtension}
                    helperText={errors?.lClient?.headOffice?.phoneExtension ? errors.lClient?.headOffice?.phoneExtension.message : null}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField variant="standard" size="small" label="Fax" fullWidth margin="dense" 
                    {...register("lClient.headOffice.fax")} 
                    error={!!errors?.lClient?.headOffice?.fax}
                    helperText={errors?.lClient?.headOffice?.fax ? errors.lClient?.headOffice?.fax.message : null}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField variant="standard" size="small" label="Email" fullWidth margin="dense" 
                    {...register("lClient.headOffice.email", 
                        {required: ValidationMessages.REQUITED_MESSAGE,               
                         pattern: {
                            value: DataPattern.PATTERN_EMAIL_ADDRESS,
                            message: ValidationMessages.INVALID_EMAIL_ADDRESS,
                         }  
                        }
                    )} 
                    error={!!errors?.lClient?.headOffice?.email}
                    helperText={errors?.lClient?.headOffice?.email ? errors.lClient?.headOffice?.email.message : null}
                />
            </Grid>

          </Grid>
        </Box>
    );
}

// Who is subcontracting for me
export function RenderSubcontractantiSection(props) {
    console.log('Sectiune Subcontractanti...');

    const { formState: { defaultValues } } = useFormContext();

    const getClientName = (clientId) => {
        var clientName = '';

        const client = props.allClients.find( (client) => client.id === clientId );
        if(client) {
            clientName = client.generalSection.clientName;
        }

        return clientName;
    }

    const columns = [
        {
            field: 'subcontractorName',
            headerName: 'Subcontractant',
            width: 400,
            valueGetter: (params) => getClientName(params.row.generalSection.clientId),
            renderCell: (params) => {
                return (
                    <Link to={`/clients/subcon/${params.row.id}?clientId=${defaultValues.lClient.id}`}>
                        {getClientName(params.row.generalSection.clientId)}
                    </Link>
                );
            }
        },
        {
            field: 'active',
            type: 'boolean',
            headerName: 'Activ',
            width: 175,
            valueGetter: (params) => params.row.generalSection.active
        },
        {
            field: 'serviceType',
            headerName: 'Tip Serviciu',
            width: 175,
            valueGetter: (params) => params.row.generalSection.serviceType
        }
    ]

    return(
        <Stack spacing={1} sx={{marginBottom: 2}}>
            <div style={{ display: "flex" }}>
                <Box sx={{ width: '100%', marginTop: 2 }} display="flex" justifyContent="flex-end" alignItems="flex-end">
                    <Link to={`/clients/subcon/newsubcon?clientId=${defaultValues.lClient.id}`}>
                        <Button variant="outlined" sx={{ marginRight: 0.5, marginTop: 0.5 }} >Adauga Subcontractant</Button>
                    </Link>
                </Box>
            </div>

            <Box sx={{ height: 650, width: '100%', marginTop: 2, marginBottom: 2 }}>
                <DataGrid
                    getRowId={(row) => row.id}
                    rows={props.clientSubcontractanti}
                    columns={columns}
                    initialState={{
                        sorting: { sortModel: [{ field: 'subcontractorName', sort: 'asc' }] }
                    }}                            
                    pageSize={10}
                    rowsPerPageOptions={[10]}
                    checkboxSelection={false}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                />
            </Box>

        </Stack>
    );
}

// Who I am subcontracting for
export function RenderSubcontractantSection(props) {
    console.log('Sectiune Subcontractant...');

    const { formState: { defaultValues } } = useFormContext();

    const [isFetchingEr, setIsFetchingEr] = React.useState(false);
    const [isFetchingWs, setIsFetchingWs] = React.useState(false);

    const [allClients, setAllClients] = React.useState(props.allClients);
    const [allEmployers, setAllEmployers] = React.useState([]);
    const [allWorksites, setAllWorksites] = React.useState([]);


    useEffect(() => {
        loadEmployersSubconClients();
        loadWorksitesForSubconClients();
    }, []);


    const loadEmployersSubconClients = async () => {
        var er = [];
        setIsFetchingEr(true);
        for(const subcon of props.clientSubcontracted) {
            const ddbEr =  await RestCalls.fetchAllEmployersForClient(subcon.generalSection.subconForClientId)
                                    .catch(error => console.log(error)); 
            er = er.concat(ddbEr);
        }
        setIsFetchingEr(false);
        setAllEmployers(er);
    }


    const loadWorksitesForSubconClients = async () => {
        var ws = [];
        setIsFetchingWs(true);
        for(const subcon of props.clientSubcontracted) {
            const ddbWs =  await RestCalls.fetchAllWorksitesForClient(subcon.generalSection.subconForClientId)
                                    .catch(error => console.log(error)); 
            ws = ws.concat(ddbWs);
        }
        setIsFetchingWs(false);
        setAllWorksites(ws);
    }


    const createRowData = (clientName, isActive, employerName, worksiteName) => {
        return {clientName, isActive, employerName, worksiteName};
    }

    const getSubcontractorRows = () => {
        var rows = [];
        for(const subcon of props.clientSubcontracted) {
            const client = allClients.find( (client) => client.id ===  subcon.generalSection.subconForClientId )
            if(client) {
                const row = createRowData(client.generalSection.clientName, subcon.generalSection.active, '', '');
                rows = rows.concat(row);

                if(subcon.generalSection.permissionedWS) {
                    for(const wsKeyId of subcon.generalSection.permissionedWS) {
                        if(!AFUtility.isString(wsKeyId) || !wsKeyId.includes('#'))
                            continue;
                        const wsId = parseInt(wsKeyId.split('#')[1]);
                        const worksite = allWorksites.find(ws => ws.id === wsId)
                        if(worksite) {
                            const wsName = worksite.generalSection.name 
                                            + ', '
                                            + worksite.generalSection.localitate
                                            + ', '
                                            + worksite.generalSection.judet;

                            const employer = allEmployers.find(employer => employer.id === worksite.generalSection.employerId)
                            const erName = employer?.generalSection?.employerName;

                            const row = createRowData('', '', erName, wsName);
                            rows = rows.concat(row);
                        }
                    }
                }
            }

        }

        return rows;
    }

    const rowsData = getSubcontractorRows();




    return(
        <Box sx={CustomStyles.boxStyles}>
            {/* <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Date Subcontractor</Typography> */}
    
            <Box sx={{ marginTop: 2, marginBottom: 2, marginLeft: 2, marginRight: 2 }}>

                {isFetchingEr || isFetchingWs ? 
                    <Loading />
                        :                    
                    <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                        <TableRow>
                            <TableCell>Subcontractant pentru</TableCell>
                            <TableCell  style={{width: '30px'}}>Activ</TableCell>
                            <TableCell>Angajator</TableCell>
                            <TableCell>Punct&nbsp;de&nbsp;Lucru</TableCell>
                        </TableRow>
                        </TableHead>
                        <TableBody>
                        {rowsData.map((row) => (
                            <TableRow
                                key={Math.random()}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">
                                    {row.clientName}
                                </TableCell>
                                <TableCell>
                                    { typeof row.isActive === 'boolean' ? 
                                        (row.isActive ? <CheckIcon /> : <ClearIcon />) 
                                            : 
                                        ''
                                    }
                                </TableCell>
                                <TableCell>{row.employerName}</TableCell>
                                <TableCell>{row.worksiteName}</TableCell>
                            </TableRow>
                        ))}
                        </TableBody>
                    </Table>
                    </TableContainer>
                }
            </Box>

        </Box>
    );
}
